import { takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { postMessageActions } from './actions';
import { IPostMessageSendModel } from './types';

export function* watchPostMessageService() {
  yield takeEvery(postMessageActions.sendMessage.type, handleSendMessage);
}

function handleSendMessage({ payload }: PayloadAction<IPostMessageSendModel>) {
  const { message, data, targetSelector } = payload;

  if (!targetSelector) {
    window.parent.postMessage({ message, data }, '*');

    return;
  }

  const iframes: NodeListOf<HTMLIFrameElement> =
    document.querySelectorAll(targetSelector);

  iframes.forEach(({ contentWindow }) => {
    if (contentWindow) contentWindow.postMessage({ message, data }, '*');
  });
}
